// extracted by mini-css-extract-plugin
module.exports = {"container":"DeliveryChangeRequestModal_container_rkLjX","actions":"DeliveryChangeRequestModal_actions_2txU-","right":"DeliveryChangeRequestModal_right_2fJsB"};